import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap"


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import { Message,Notification,MessageBox } from 'element-ui';


import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

import api from './config.js'
import utils from './utils.js'
Vue.prototype.$api = api
Vue.prototype.$utils = utils

Vue.prototype.$message=Message
Vue.prototype.$notify=Notification
Vue.prototype.$confirm=MessageBox

import axios from 'axios'
axios.defaults.withCredentials=true
Vue.prototype.$axios = axios;

import Cookies from 'vue-cookies'
Vue.prototype.$cookie = Cookies;


import $ from 'jquery'
window.$ = $
window.jQuery = $
export default $


Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
